import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import component from 'bundles/about/routes';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

// remove the grid import once all bt3-container, bt3-row and bt3-col classes are removed from this bundle
import 'css!bundles/about/components/styl/grid';
import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);

export default appEnv;
